<template>
  <b-card title="Pole detail" body-class="pole-card">
    <table class="table">
      <tbody>
        <tr>
          <td><strong>Circuit Name</strong></td>
          <td>{{circuit_name}}</td>
        </tr>
        <tr>
          <td><strong>Circuit Voltage</strong></td>
          <td>{{circuit_type}}</td>
        </tr>
        <tr>
          <td><strong>Substation Name</strong></td>
          <td>{{pole_substation_name_}}</td>
        </tr>
        <tr>
          <td><strong>Substation Number</strong></td>
          <td>{{pole_substation_number_}}</td>
        </tr>
        <tr>
          <td><strong>HV Pole Number</strong></td>
          <td>{{hv_pole_number_}}</td>
        </tr>
        <tr>
          <td><strong>Pole Type</strong></td>
          <td>{{pole_type ? pole_type : 'Undefined'}}</td>
        </tr>
        <tr>
          <td><strong>Pole Latitude</strong></td>
          <td>{{pole_latitude ? pole_latitude + '°' : ''}}</td>
        </tr>
        <tr>
          <td><strong>Pole Longitude</strong></td>
          <td>{{pole_longitude ? pole_longitude + '°' : ''}}</td>
        </tr>
        <tr>
          <td><strong>Pole Notes</strong></td>
          <td>{{truncateString(pole_notes, 15)}}</td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>
<script>
export default {
  name: 'PoleDetailCard',
  props: ['pole'],
  computed: {
    pole_substation_name_(){
      return this._props.pole ? this._props.pole.pole_substation_name : '';
    },
    hv_pole_number_(){
      return this._props.pole ? this._props.pole.hv_pole_number : '';
    },
    pole_substation_number_(){
      return this._props.pole ? this._props.pole.pole_substation_number : '';
    },
    pole_type(){
      return this._props.pole ? this._props.pole.type : '';
    },
    pole_notes(){
      return this._props.pole ? this._props.pole.notes : '';
    },
    pole_longitude(){
      return this._props.pole && this._props.pole.coordinates ? this._props.pole.coordinates.longitude : '';
    },
    pole_latitude(){
      return this._props.pole && this._props.pole.coordinates ? this._props.pole.coordinates.latitude : '';
    },
    circuit_name(){
      return this._props.pole ? this._props.pole.circuit_name : '';
    },
    circuit_type(){
      return this._props.pole ? this._props.pole.circuit_type : '';
    },
  },
  methods: {
    truncateString(str, maxLength) {
      if (str && (str.length > maxLength)) {
        return str.slice(0, maxLength) + '...';
      } else {
        return str
      }
    }
  }
}
</script>

<style src="./PoleDetailCard.scss" lang="scss" scoped/>
